import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

/**
 * Headless detector for the New Ticket form: when a full contact number that
 * belongs to an existing customer is entered, it auto-opens the side Customer
 * History panel (once per country+number). Renders nothing — the previous
 * in-form summary pill was removed since the always-on side panel shows the
 * same information.
 */
export default function CustomerHistoryIndicator({ countryCode, contactNumber, onViewHistory }) {
  const autoOpenedFor = useRef(null);
  const ready = contactNumber && contactNumber.replace(/\D/g, "").length >= 6;

  useEffect(() => {
    if (!ready) return;
    let abort = false;
    api
      .get("/customers/contact-summary", {
        params: { contact_number: contactNumber, country_code: countryCode, limit: 1 },
      })
      .then((r) => {
        if (abort) return;
        const d = r.data || null;
        const key = `${countryCode}|${contactNumber}`;
        if (d && d.total > 0 && autoOpenedFor.current !== key) {
          autoOpenedFor.current = key;
          onViewHistory?.(countryCode, contactNumber);
        }
      })
      .catch(() => { /* ignore */ });
    return () => { abort = true; };
  }, [ready, contactNumber, countryCode]);

  return null;
}
